import React from "react";
import Footer from "../Component/Footer/Footer";
import Header from "../Component/Header/Header";
import Biddingpage from "../Pages/Biddingpage/Biddingpage";
import MuseumsBrowse from "../Component/MuseumsBrowse/MuseumsBrowse";
import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Biddingtheme() {
  return (
    <>
      <Header />
      <Biddingpage />
      <MuseumsBrowse />
      <Latestupdate />
      <Footer />
    </>
  );
}
